import { forwardRef, type Ref, type SVGProps } from "react";
const IconTaxOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M7 8h6a1 1 0 0 0 0-2H7a1 1 0 0 0 0 2m5.29 17.71a1 1 0 0 0 1.42 0l6-6a1 1 0 0 0-1.42-1.42l-6 6a1 1 0 0 0 0 1.42" />
    <path d="M13 18a1 1 0 1 0 0 2 1 1 0 1 0 0-2" />
    <path d="M19 24a1 1 0 1 0 0 2 1 1 0 1 0 0-2" />
    <path d="M9 10H7a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2" />
    <path d="M26 2H6C3.5 2 2 3.87 2 7v21a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V7c0-2.8 1.68-3 2-3 .08 0 2 0 2 3a3.44 3.44 0 0 1-2.32 3.05 1 1 0 1 0 .64 1.9C26.47 11.9 30 10.68 30 7c0-4-2.62-5-4-5m-4 5v21H4V7c0-3 1.5-3 2-3h16.7a5.93 5.93 0 0 0-.7 3" />
  </svg>
);
const ForwardRef = forwardRef(IconTaxOutlineSVG);
ForwardRef.displayName = "IconTaxOutline";
export { ForwardRef as IconTaxOutline };
